// Re-export all constants
export * from './notifications';
export * from './dashboard';
export * from './table';
export * from './info_pane';

export const REQUEST_STATUS = {
  idle: 'idle',
  loading: 'loading',
  succeeded: 'succeeded',
  failed: 'failed',
}
